export default __webpack_public_path__ + "static/media/regulatory--stay-in-lane--g1.56d686b0.png";